import { AnswerListLang } from './answerList/answerList.lang';
import { answerDetailLang } from './answerDetail/answerDetail.lang';

export const publishDetailLang = {
    answers: 'پاسخنامه',
    questions: 'پرسشنامه',
    wrongPassErr: 'رمز عبور وارد شده صحیح نیست. لطفا مجددا تلاش کنید',
    noInternet: 'از اتصال دستگاه به اینترنت جهت ارسال رمز عبور اطمینان حاصل فرمایید',
    noQuota: 'سهمیه ثبت پاسخنامه شما به اتمام رسیده است',
    offlineStatus: 'دستگاه آفلاین بوده و این پاسخنامه بصورت آفلاین ذخیره میگردد',
    getGPSErr: 'لطفا دسترسی لازم برای دریافت موقعیت مکانی خود را فعال کنید',
    GPSnotAvailable: 'دریافت موقعیت مکانی از دستگاه شما میسر نمی‌باشد',
    GPSFailed: 'دریافت موقعیت مکانی با خطا مواجه شد',
    GPSPermissionDenied: 'دسترسی به موقعیت مکانی دستگاه شما غیرفعال است',
    answerList: AnswerListLang,
    answerDetail: answerDetailLang,
};
